/**
 * Pazaak Side Deck Slots
 * 
 * @file PazaakSideDeckSlots.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 */
export enum PazaakSideDeckSlots {
  INVALID = -1,
  SLOT_1 = 0,
  SLOT_2 = 1,
  SLOT_3 = 2,
  SLOT_4 = 3,
  SLOT_5 = 4,
  SLOT_6 = 5,
  SLOT_7 = 6,
  SLOT_8 = 7,
  SLOT_9 = 8,
  SLOT_10 = 9,
  MAX_SLOTS = 10
}
